import React, { Fragment } from 'react';
import { useSelector } from 'react-redux'
import { arrayOf, string, object } from 'prop-types';
import TaskErrorText from '../../../../../components/library/workflow-tasks/TaskErrorText';

const ExtraMissingFilesError = ({ completionErrorType, extraFiles, missingFiles, task, params }) => {
    const lang = useSelector(state => state.layout.lang);

    const getErrorFileList = () => {       
        var fileList = [];
        if (completionErrorType === 't1032FileMismatch') {
            const t1032MissingFiles = (missingFiles || []).filter(mf => 
                mf.file_name_en?.includes('T1032') || mf.file_name_fr?.includes('T1032')
            );

            if (t1032MissingFiles.length > 0) {
                fileList.push(t1032MissingFiles.map((mf, j) =>
                    <TaskErrorText errorKey='PrepareTask.ErrorCompleteFile' classNames='mt-4 mb-4'
                        params={{ FileName: lang === 'fr' ? mf.file_name_fr : mf.file_name_en }}
                        key={`mf-${j}`}
                    />)
                )
            }
        }
        else {
            if (missingFiles) {
                const hasExtraFiles = extraFiles && extraFiles.length > 0;
                fileList.push(missingFiles.map((mf,j) =>
                    <TaskErrorText errorKey='PrepareTask.ErrorCompleteFile' 
                        classNames={
                            j === 0 ? 'mt-4 mb-1' : 
                            !hasExtraFiles && j === missingFiles.length - 1 ? 'mt-1 mb-4' : 
                            'my-1'
                        }
                        params={{ FileName: lang === 'fr' ? mf.file_name_fr : mf.file_name_en }}
                        key={`mf-${j}`}
                    />)
                )
            }
            if (extraFiles) {
                const hasMissingFiles = missingFiles && missingFiles.length > 0;
                fileList.push(extraFiles.map((ef,i) =>
                    <TaskErrorText errorKey='PrepareTask.ErrorCompleteFile' 
                        classNames={
                            !hasMissingFiles && i === 0 ? 'mt-4 mb-1' : 
                            i === extraFiles.length - 1 ? 'mt-1 mb-4' : 
                            'my-1'
                        }
                        params={{ FileName: ef }} key={`ef-${i}`}
                    />)
                )
            }
        }

        return fileList;
    }
    return (
        <Fragment>
            <TaskErrorText errorKey={task != 'fileReturn' ? `PrepareTask.ErrorComplete1.${task}.${completionErrorType}` : `FileReturnTask.ErrorMissingFiles1`}
                params={params} />
            { getErrorFileList() }
            <TaskErrorText errorKey={task != 'fileReturn' ? `PrepareTask.ErrorComplete2.${task}.${completionErrorType}` : `FileReturnTask.ErrorMissingFiles2`}
                classNames='mt-2' params={params} />
        </Fragment>
    )
}

ExtraMissingFilesError.whyDidYouRender = false;

ExtraMissingFilesError.propTypes = {
    task: string.isRequired,
    extraFiles: arrayOf(string),
    missingFiles: arrayOf(object),
    completionErrorType: string,
    params: object
}

export default ExtraMissingFilesError